// extracted by mini-css-extract-plugin
module.exports = {"action":"MobileSideDrawerProfileAction_action__bAw5K"};